import React from 'react';
import chashushuli from '../../images/chashushuli.png';
import chakhokhbili from '../../images/chakhokhbili.png';
import khinkali from '../../images/khinkali-round.png';
import skewer from '../../images/bonskewer.png';
import khachapuri from '../../images/khachapuri-round.png';
import cheese from '../../images/cheese-wine.png';
import couvert from '../../svg/svg-couvert.svg';
import {useTranslation } from "react-i18next";   

function Specials() {
  const { t, i18n } = useTranslation();
    return (
        <section id="specials" className="specials">
          <div className="baniere-3"></div>
          <div className="container">
            <div className="section-title">
              <h2>{t("specialities")} <img src={couvert} className="i-couvert" alt="Book a table at Old Tbilisi restaurant"></img></h2>
              <p>{t("discover-specialities")}</p>
            </div>
              
            <div className="row">
              <div className="col-lg-3">
                <ul className="nav nav-tabs flex-column">                 
                  <li className="nav-item">
                    <a className="nav-link active show" data-bs-toggle="tab" href="#tab-2">Khinkali</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#tab-3">{t("sp-2-name")}</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#tab-4">Khachapuri {t("and")} {t("sp-3-name-2")}</a>
                  </li>               
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#tab-1">Chashushuli {t("and")} Chakhokhbili</a>
                  </li>
                </ul>  
              </div>
              {/* TABS CONTENT*/}
              <div className="col-lg-9 mt-4 mt-lg-0">
                <div className="tab-content">
                    {/* TAB SPECIAL ONE*/}
                  <div className="tab-pane" id="tab-1">
                    <div className="row">
                      <div className="col-lg-8 details order-1 order-lg-1">
                        <h3 className="text-old text-center">Chashushuli</h3>
                        <p className='mb-3'><span className='slash'></span> {t("sp-4-p-1")}</p>
                        <p className=" text-orange mb-5">- <span className="text-white">{t("sp-4-li-1-white")} </span>{t("sp-4-li-1-orange")}</p>
                      </div>
                      <div className="col-lg-4 order-2 order-lg-2">
                        <img src={chashushuli} alt="Chashushuli - Veal, prepared with tomatoes, herbs and garlic" className="img-fluid pb-2"/>
                      </div>
                    </div>
                    <div className="row">
                      <div className="center col-lg-4 order-2 order-lg-1">
                        <img src={chakhokhbili} alt="Chakhokhbili - Slices of stewed chicken, mixed with onions, herbs, garlic and spices" className="img-fluid special-img-max"/>
                      </div>
                      <div className="col-lg-8 details order-1 order-lg-2">
                        <h3 className="text-old text-center">Chakhokhbili</h3>
                        <p className='mb-3'><span className='slash'></span> {t("sp-4-p-2")}</p>
                        <p className=" text-orange mb-5">- <span className="text-white"> {t("sp-4-li-2-white")} </span> {t("sp-4-li-2-orange")}</p>                    
                      </div>
                    </div>
                  </div>
                   {/* TAB SPECIAL TWO*/}
                  <div className="tab-pane active show" id="tab-2">
                    <div className="row">            
                      <div className="col-lg-12 details center">
                        <h3 className="text-old text-center">Khinkali</h3>
                        <p><span className='slash'></span> {t("sp-1-p")}</p>
                        <img src={khinkali} alt="Khinkali - Old Tbilisi" className="img-fluid max"/>
                        <p className="text-orange pt-3">-<span className="text-white"> {t("sp-1-li-1-white")}</span> : {t("sp-1-li-1-orange")}</p>
                        <p className="text-orange">- <span className="text-white">{t("sp-1-li-2-white")}</span> : {t("sp-1-li-2-orange")}</p>
                        <p className="text-orange">- <span className="text-white">{t("sp-1-li-2-white")}</span> : {t("sp-1-li-2-orange")}</p>                        
                      </div>                    
                    </div>
                  </div>
                  {/* TAB SPECIAL TREE*/}
                  <div className="tab-pane" id="tab-3">
                    <div className="row">
                      <div className="col-lg-12 details center">
                        <h3 className="text-old text-center">{t("sp-2-name")}</h3>
                        <p><span className='slash'></span> {t("sp-2-p")}</p>
                        <img src={skewer} alt="Barbecue on a Skewer - Old Tbilisi" className="img-fluid max"/>
                        <p className="text-orange pt-3">- <span className="text-white">{t("sp-2-li-1-white")}</span></p>
                        <p className="text-orange ">- <span className="text-white">{t("sp-2-li-2-white")}</span>: {t("sp-2-li-2-orange")}</p>
                        <p className="text-orange ">- <span className="text-white">{t("sp-2-li-3-white")}</span>: {t("sp-2-li-3-orange")}</p>
                        <p className="text-orange">- <span className="text-white">{t("sp-2-li-4-white")}</span>: {t("sp-2-li-4-orange")} </p>
                      </div>                   
                    </div>
                  </div>
                  {/* TAB SPECIAL FOUR*/}            
                  <div className="tab-pane" id="tab-4">
                    <div className="row">
                      <div className="col-lg-8 details order-1 order-lg-1">
                        <h3 className="text-old text-center">Khachapuri</h3>
                        <p className='mb-3'><span className='slash'></span> {t("sp-3-p-1")}</p>
                        <p className=" text-orange pb-5">- <span className="text-white">{t("sp-3-li-1-white")}</span>{t("sp-3-li-1-orange")}</p>
                      </div>
                      <div className="center col-lg-4 order-2 order-lg-2">
                        <img src={khachapuri} alt="Chashushuli - Veal, prepared with tomatoes, herbs and garlic" className="img-fluid special-img-max pb-2"/>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-4 text-center order-2 order-lg-1">
                        <img src={cheese} alt="Chakhokhbili - Slices of stewed chicken, mixed with onions, herbs, garlic and spices" className="img-fluid"/>
                      </div>
                      <div className="col-lg-8 details order-1 order-lg-2">
                        <h3 className="text-old text-center"> {t("sp-3-name-2")}</h3>                                           
                        <p className='mb-3'><span className='slash'></span> {t("sp-3-p-2")}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>             
            </div>
          </div>
        </section>
    )
}

export default Specials;
